import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { ReactionIcon } from './ReactionIcon';

export const reactionIconPropertyLayout = LockablePropertyStripLayout<ReactionIcon>((d, s, o, w, a) => [
    // a.get('url') && isColorable(a.get('url')!) &&
    // w.createColorSelector({
    //     autoSelect: true,
    //     groups: true,
    //     value: getColor(a.get('url')!),
    //     text: 'Icon Color',
    //     onSelect() {
    //         o.update(u => {
    //             u.rolling(a.keyFor('url'));
    //             const urlObj = new URL(a.get('url')!);
    //             urlObj.searchParams.set('color', this.value!);
    //             a.set('url', urlObj.toString());
    //         });
    //     }
    // }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
